// extracted by mini-css-extract-plugin
export var option = "_bu-0";
export var optionCard = "_bu-f";
export var optionContent = "_bu-g";
export var optionIcon = "_bu-i";
export var optionIconBox = "_bu-h";
export var optionLabel = "_bu-j";
export var optionPill = "_bu-m";
export var optionPillBadge = "_bu-p";
export var optionPillIcon = "_bu-n";
export var optionPillLabel = "_bu-o";
export var optionRadio = "_bu-k";
export var optionRadioInner = "_bu-l";
export var optionReveal = "_bu-2";
export var optionRevealDelay0 = "_bu-3";
export var optionRevealDelay1 = "_bu-4";
export var optionRevealDelay10 = "_bu-d";
export var optionRevealDelay11 = "_bu-e";
export var optionRevealDelay2 = "_bu-5";
export var optionRevealDelay3 = "_bu-6";
export var optionRevealDelay4 = "_bu-7";
export var optionRevealDelay5 = "_bu-8";
export var optionRevealDelay6 = "_bu-9";
export var optionRevealDelay7 = "_bu-a";
export var optionRevealDelay8 = "_bu-b";
export var optionRevealDelay9 = "_bu-c";
export var optionSelected = "_bu-1";